import { observable } from 'mobx';

export type NationalityResponseArgs = {
  id: number;
  name: string;
};

export type NationalityArgs = {
  id: number;
  name: string;
};

export const convertNationalityResponseToArgs = (response: NationalityResponseArgs) => {
  const args: NationalityArgs = {
    id: response.id,
    name: response.name
  };
  return args;
};

export default class Nationality {
  @observable id: number;
  @observable name: string;

  constructor(args: NationalityArgs) {
    this.id = args.id;
    this.name = args.name;
  }
}
